export default __webpack_public_path__ + "static/media/3.7ceea145.jpg";